export default __webpack_public_path__ + "static/media/pzLogo.f98b33aa.png";